export enum BasicColorTypes {
  HEX = 'Hex',
  RGB = 'RGB',
  HSL = 'HSL',
  KEYWORD = 'Keyword',
}
